import React from 'react';
import cx from 'classnames';
import { useIntl } from 'react-intl';

import BannerItemTextWithLink from '../BannerItemTextWithLink';
import BannerItemText from '../BannerItemText';

import { Heading4 } from '../Typography';

import styles from './index.module.scss';

enum DescriptionTextType {
  TEXT = 'text',
  TEXT_WITH_LINK = 'textWithLink',
}

export enum BackgroundColor {
  RED = 'red',
  GREEN = 'green',
  WHITE = 'white',
}

const backgroundColorMap: Record<BackgroundColor, string> = {
  [BackgroundColor.RED]: '#c8585f',
  [BackgroundColor.GREEN]: '#7C9179',
  [BackgroundColor.WHITE]: '#FFFFFF',
};

interface DescriptionItem {
  type: DescriptionTextType;
  text: string;
  link: string;
  linkText: string;
}

export interface BannerWithTextAndDescriptionProps {
  title?: string;
  description: DescriptionItem;
  backgroundColor: BackgroundColor;
}

const BannerWithTextAndDescription: React.FC<
  BannerWithTextAndDescriptionProps
> = ({ title, description, backgroundColor = BackgroundColor.RED }) => {
  const intl = useIntl();

  const translatedTitle = title
    ? intl.formatMessage({ id: title, defaultMessage: '' })
    : '';

  if (!translatedTitle.trim() || translatedTitle === title) return null;

  const bgColor = backgroundColorMap[backgroundColor];

  return (
    <div
      className={cx({
        [styles.wrapper]: true,
        [styles.color]: bgColor === backgroundColorMap[BackgroundColor.WHITE],
      })}
      style={{ backgroundColor: bgColor }}
    >
      <Heading4 className={styles.title}>{translatedTitle}</Heading4>
      {description &&
        (description.type === DescriptionTextType.TEXT_WITH_LINK ? (
          <BannerItemTextWithLink
            description={description.text}
            link={description.link}
            linkText={description.linkText}
          />
        ) : (
          <BannerItemText text={description.text} />
        ))}
    </div>
  );
};

export default BannerWithTextAndDescription;
